/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Cta_BtnInputs */

const es_exp_mk_cta_btn = /** @type {(inputs: Exp_Mk_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quiero navegar más`)
};

const gl_exp_mk_cta_btn = /** @type {(inputs: Exp_Mk_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quero navegar máis`)
};

const en_exp_mk_cta_btn = /** @type {(inputs: Exp_Mk_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to sail more`)
};

/**
* | output |
* | --- |
* | "I want to sail more" |
*
* @param {Exp_Mk_Cta_BtnInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_cta_btn = /** @type {((inputs?: Exp_Mk_Cta_BtnInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Cta_BtnInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_cta_btn(inputs)
	if (locale === "en") return en_exp_mk_cta_btn(inputs)
	return es_exp_mk_cta_btn(inputs)
});